import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2, fetch3 } from '../utils';
import icons from '../resources/icons';
import Searcher from './Searcher';
import DetailsHandlerDef from "../details/DetailsHandlerDef"; //noinspection JSCommentMatchesSignature,JSCommentMatchesSignature

/**
 *
 * @class Searches a Spatial Suite index. An S4 index must have been created and populated on the host. See https://github.com/Septima/spatialsuite-s4#5-configure-your-search-index
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.S4IndexSearcher
 * @param {Object} options S4IndexSearcher expects these properties:<br/>
 * @param {string} options.host "Service endpoint (SpatialSuite Url) eg.: [http:]//sps-demo.septima.dk[:80]. Protocol and port are optional"
 * @param {string} options.datasources Comma separated list of indexed data sources to search. Default: "*"
 *
 * @example
 * var s4IndexSearcherOptions = {
 *     host : "sps-demo.septima.dk",
 *     onSelect : function(result) {
 *          log('<b>'+ Spatial Suite objekt + ':</b> '+ result.title + '<br/>');
 *     },
 *     datasources : "*",
 *     matchesPhrase: "Begynder med ",
 *     searchDelay: 200
 * };
 * searchers.push({title : '', searcher : new Septima.Search.S4IndexSearcher(s4IndexSearcherOptions)});
 *
 */

export default Class(Searcher,
/**  @lends Septima.Search.S4IndexSearcher# */
{
  indexedDatasources: null,
  datasourcesToSearch: "*",

  /**
   * This function is called when a result is selected.
   * @callback Septima.Search.S4IndexSearcher~selectCallback
   * @param {Object} result
   * @param result.title {string}
   * @param result.description {string}
   * @param result.data {object} S4IndexResult
   * @param result.data.heading {string} title
   */
  initialize: function initialize(options) {
    options.usesGeoFunctions = true;
    if (!options.source) options.source = "WebGis";
    this.source = options.source;
    this.Searcher(options);
    if (options === undefined) throw "New Septima.Search.S4IndexSearcher(options): Options missing.";
    this.indexedDatasources = null;
    this.ajaxURL = '';
    if (options.host) this.ajaxURL = options.host.replace(/\/$/, ""); //remove trailing slash
    else if (options.indexProtocol && options.indexHost && options.indexPort) this.ajaxURL = options.indexProtocol + '://' + options.indexHost + ':' + options.indexPort;
    this.allowDetails = false;
    if (options.allowDetails) this.allowDetails = options.allowDetails;

    if (options.datasources === undefined) {
      this.datasourcesToSearch = "*";
    } else {
      this.datasourcesToSearch = options.datasources;
      if (this.datasourcesToSearch === "" || this.datasourcesToSearch === " ") this.datasourcesToSearch = "*";
    }

    this.datasourcesReady = this.getDatasources();
  },
  ready: function ready() {
    return this.datasourcesReady;
  },
  getDatasources: function () {
    var _getDatasources = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var url, data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, datasource;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.indexedDatasources === null)) {
                _context.next = 26;
                break;
              }

              this.indexedDatasources = [];
              url = this.ajaxURL + '/jsp/modules/s4/getDatasources.jsp';
              _context.next = 5;
              return fetch3(url, {});

            case 5:
              data = _context.sent;

              if (!(typeof data.results !== 'undefined')) {
                _context.next = 26;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 10;

              for (_iterator = data.results[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                result = _step.value;
                datasource = result.datasource;

                if (datasource.featurecount > 0 && this.inDatasourcesToSearch(datasource.id)) {
                  this.indexedDatasources.push(datasource);
                  this.registerType(this.source, datasource.featuretypesingle);
                }
              }

              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 18:
              _context.prev = 18;
              _context.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context.prev = 21;

              if (!_didIteratorError) {
                _context.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context.finish(21);

            case 25:
              return _context.finish(18);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[10, 14, 18, 26], [19,, 21, 25]]);
    }));

    function getDatasources() {
      return _getDatasources.apply(this, arguments);
    }

    return getDatasources;
  }(),
  inDatasourcesToSearch: function inDatasourcesToSearch(datasource) {
    if (this.datasourcesToSearch == "*") {
      return true;
    } else {
      var arrDatasourcesToSearch = this.datasourcesToSearch.split(" ");
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = arrDatasourcesToSearch[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var arrDatasource = _step2.value;
          if (arrDatasource.toLowerCase() == datasource.toLowerCase()) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return false;
  },
  getDatasourceFromType: function getDatasourceFromType(type) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.indexedDatasources[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var indexedDatasource = _step3.value;
        if (type.toLowerCase() == indexedDatasource.featuretypesingle.toLowerCase()) return indexedDatasource;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return "";
  },
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.datasourcesReady;

            case 2:
              _context2.next = 4;
              return this.mySq(query);

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function sq(_x) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  mySq: function () {
    var _mySq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(query) {
      var datasources, params, fetchOptions, fetch2Use, url, data, queryResult, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, result, datasource, features, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, feature, resultGeometry, _result;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              datasources = this.datasourcesToSearch;
              if (query.hasTarget) if (this.hasType(query.target.type)) {
                datasources = this.getDatasourceFromType(query.target.type).id;
              }
              params = {
                datasources: datasources,
                limit: query.limit
              };
              if (query.wkt) params.querywkt = query.wkt;

              if (query.distWkt) {
                params.distwkt = query.distWkt; //Backwards compatibility

                params.wkt = query.distWkt;
              }

              fetchOptions = {
                data: params
              };

              if (this.ajaxURL === "") {
                fetch2Use = fetch2;
                fetchOptions.method = 'post';
                fetchOptions.credentials = "include";
              } else {
                fetch2Use = fetch3;
              }

              url = this.ajaxURL + '/jsp/modules/s4/queryIndex.jsp';
              _context3.next = 10;
              return fetch2Use(url, fetchOptions);

            case 10:
              data = _context3.sent;
              queryResult = this.createQueryResult();
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context3.prev = 15;
              _iterator4 = data.results[Symbol.iterator]();

            case 17:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context3.next = 44;
                break;
              }

              result = _step4.value;
              datasource = result.datasource;
              features = result.features;

              if (!(features.length > 0)) {
                _context3.next = 41;
                break;
              }

              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context3.prev = 25;

              for (_iterator5 = features[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                feature = _step5.value;
                resultGeometry = this.translateWktToGeoJsonObject(feature.wkt);
                _result = queryResult.addResult(this.source, datasource.featuretypesingle, feature.title, feature.description, resultGeometry, feature);
                _result.id = feature.featureid;
                if (datasource.iconuri !== undefined) _result.image = datasource.iconuri;
                _result.distance = feature.properties.distance;
              }

              _context3.next = 33;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](25);
              _didIteratorError5 = true;
              _iteratorError5 = _context3.t0;

            case 33:
              _context3.prev = 33;
              _context3.prev = 34;

              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }

            case 36:
              _context3.prev = 36;

              if (!_didIteratorError5) {
                _context3.next = 39;
                break;
              }

              throw _iteratorError5;

            case 39:
              return _context3.finish(36);

            case 40:
              return _context3.finish(33);

            case 41:
              _iteratorNormalCompletion4 = true;
              _context3.next = 17;
              break;

            case 44:
              _context3.next = 50;
              break;

            case 46:
              _context3.prev = 46;
              _context3.t1 = _context3["catch"](15);
              _didIteratorError4 = true;
              _iteratorError4 = _context3.t1;

            case 50:
              _context3.prev = 50;
              _context3.prev = 51;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 53:
              _context3.prev = 53;

              if (!_didIteratorError4) {
                _context3.next = 56;
                break;
              }

              throw _iteratorError4;

            case 56:
              return _context3.finish(53);

            case 57:
              return _context3.finish(50);

            case 58:
              return _context3.abrupt("return", queryResult);

            case 59:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[15, 46, 50, 58], [25, 29, 33, 41], [34,, 36, 40], [51,, 53, 57]]);
    }));

    function mySq(_x2) {
      return _mySq.apply(this, arguments);
    }

    return mySq;
  }(),
  getIndexedDatasourcesAsNewQueries: function getIndexedDatasourcesAsNewQueries() {
    var queryResult = this.createQueryResult();
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = this.indexedDatasources[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var datasource = _step6.value;
        var result = queryResult.addNewQuery(this.source, datasource.featuretypesingle, datasource.featuretypeplural + " (" + datasource.featurecount + ")", null, "", null, null);
        if (datasource.iconuri !== undefined) result.image = datasource.iconuri;
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    return queryResult;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(query, caller) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.datasourcesReady;

            case 3:
              this.myFetchData(query, caller);
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              caller.fetchError();

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 6]]);
    }));

    function fetchData(_x3, _x4) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  myFetchData: function () {
    var _myFetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(query, caller) {
      var datasources, limitType, url, data;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = query.type;
              _context5.next = _context5.t0 === 'collapse' ? 3 : _context5.t0 === 'cut' ? 5 : _context5.t0 === 'no-cut' ? 5 : _context5.t0 === 'list' ? 5 : 21;
              break;

            case 3:
              caller.fetchSuccess(this.getIndexedDatasourcesAsNewQueries());
              return _context5.abrupt("break", 21);

            case 5:
              datasources = this.datasourcesToSearch;
              if (query.hasTarget) datasources = this.getDatasourceFromType(query.target.type).id;
              limitType = "collapse";
              if (query.type == 'list.force') limitType = "cut";
              url = this.ajaxURL + '/jsp/modules/s4/queryIndex.jsp';
              _context5.prev = 10;
              _context5.next = 13;
              return fetch3(url, {
                data: {
                  query: query.queryString,
                  limit: query.limit + 2,
                  datasources: datasources,
                  limitType: limitType
                }
              });

            case 13:
              data = _context5.sent;
              data.query = query;
              caller.fetchSuccess(this.parseResult(data));
              _context5.next = 21;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t1 = _context5["catch"](10);
              caller.fetchError();

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[10, 18]]);
    }));

    function myFetchData(_x5, _x6) {
      return _myFetchData.apply(this, arguments);
    }

    return myFetchData;
  }(),
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(id, type) {
      var datasource, url, data, feature, queryResult, resultGeometry, description, result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.datasourcesReady;

            case 2:
              datasource = this.getDatasourceFromType(type);
              url = this.ajaxURL + '/jsp/modules/s4/getFeature.jsp';
              _context6.next = 6;
              return fetch3(url, {
                data: {
                  id: id,
                  datasource: datasource.id
                }
              });

            case 6:
              data = _context6.sent;
              feature = data;
              queryResult = this.createQueryResult();
              feature.datasource = datasource;
              resultGeometry = this.translateWktToGeoJsonObject(feature.wkt);
              description = this.getFeatureDescription(feature);
              result = queryResult.addResult(this.source, datasource.featuretypesingle, feature.title, description, resultGeometry, feature);
              result.id = feature.featureid;
              return _context6.abrupt("return", result);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function get(_x7, _x8) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  datasourceInResults: function datasourceInResults(indexedDatasource, results) {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = results[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var result = _step7.value;
        if (indexedDatasource.id === result.datasource.id) return true;
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return false;
  },
  parseResult: function parseResult(data) {
    var queryResult = this.createQueryResult();
    var query = data.query;

    if (!query.hasTarget) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.indexedDatasources[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var indexedDatasource = _step8.value;

          if (indexedDatasource.featuretypesingle.toLowerCase().indexOf(query.queryString.toLowerCase()) === 0 && !this.datasourceInResults(indexedDatasource, data.results)) {
            var autoNewQuery = queryResult.addNewQuery(this.source, indexedDatasource.featuretypesingle, indexedDatasource.featuretypeplural, null, "", null, null);
            if (indexedDatasource.iconuri !== undefined) autoNewQuery.image = indexedDatasource.iconuri;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = data.results[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var result = _step9.value;
        var description = void 0;
        var datasource = result.datasource;
        var type = datasource.featuretypesingle;

        if (result.type == 'DatasourceWithMatchingFeaturesIncluded') {
          var count = result.features.length;
          var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = result.features.slice(0, hitsShown)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var feature = _step10.value;
              feature.datasource = datasource;
              this.addResultFromFeature(query, queryResult, feature, type);
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) {
            var newQuery = queryResult.addNewQuery(this.source, type, datasource.featuretypeplural, null, query.queryString, null, null);
            if (datasource.iconuri !== undefined) newQuery.image = datasource.iconuri;
          }
        } else if (result.type == 'DatasourceWithMatchingFeatures') {
          description = null;

          var _newQuery = queryResult.addNewQuery(this.source, type, datasource.featuretypeplural + " (" + datasource.featurecount + ")", description, query.queryString, null, null);

          if (datasource.iconuri !== undefined) _newQuery.image = datasource.iconuri;
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    return queryResult;
  },
  addResultFromFeature: function addResultFromFeature(query, queryResult, feature, type) {
    var resultGeometry = this.translateWktToGeoJsonObject(feature.wkt);
    var description = this.getFeatureDescription(feature);
    var result1;
    if (query.hasTarget) result1 = queryResult.addResult(this.source, type, feature.title, description, resultGeometry, feature);else result1 = queryResult.addResult(this.source, type, feature.title + " (" + type + ")", description, resultGeometry, feature);
    result1.id = feature.featureid;
    if (feature.datasource.iconuri !== undefined) result1.image = feature.datasource.iconuri;
  },
  getFeatureDescription: function getFeatureDescription(feature) {
    return feature.description;
  },
  hasDetails: function hasDetails(result) {
    var feature = result.data;
    if (this.allowDetails) {
      if (typeof feature.hasDetails === "undefined") {
        feature.hasDetails = false;

        if (this.getCustomButtonsForResult(result).length > 0) {
          feature.hasDetails = true;
          return true;
        }

        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = feature.pcol.row[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var row = _step11.value;

            if (typeof row._name !== "undefined" && (row._name !== 'column' || row._name === 'column' && row.format === '' || row.format === 'hyperlink')) {
              feature.hasDetails = true;
              return true;
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }
      } else {
        return feature.hasDetails;
      }
    } else return false;
  },
  getDetailHandlersForResult: function getDetailHandlersForResult(result) {
    var feature = result.data;
    var detailHandlerDefs = [];

    if (this.hasDetails(result)) {
      var detailsHandler = function detailsHandler() {
        return new Promise(function (resolve) {
          var items = [];
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = feature.pcol.row[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var row = _step12.value;
              if (typeof row._name !== "undefined" && (row._name !== 'column' || row._name === 'column' && row.format === '' || row.format === 'hyperlink' || row.format === 'imageURL')) if (row.format === 'hyperlink') {
                var icon = icons.linksymbol;
                var linkTitle = row.label;
                var link = row.value;
                items.push({
                  type: "link",
                  linkTitle: linkTitle,
                  link: link,
                  icon: icon
                });
              } else if (row.format === 'imageURL') {
                var label = row.label;
                var value = row.value;
                items.push({
                  type: "image",
                  label: label,
                  value: value
                });
              } else {
                var _label = row.label;
                var _value = row.value;
                items.push({
                  type: "labelvalue",
                  label: _label,
                  value: _value
                });
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          resolve(items);
        });
      };

      var detailHandlerDef = new DetailsHandlerDef({
        "buttonText": "Attributter",
        "buttonImage": icons.details.moreHeader,
        "handler": detailsHandler,
        "more": true
      });
      detailHandlerDefs.push(detailHandlerDef);
    }

    return detailHandlerDefs;
  },
  getCustomButtonsForResult: function getCustomButtonsForResult() {
    var customButtonDefs = [];
    return customButtonDefs;
  },
  CLASS_NAME: 'Septima.Search.S4IndexSearcher'
});